import React from "react";
import { useMyStore } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useLanguage } from "../core/hooks/useLanguage";
import { getStoreContacts } from "./API/core.service";
import { useStoreId } from "../core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "../constants/clientTime";

export function useStoreContactsEnabled() {
  const language = useLanguage();
  const store = useMyStore();
  const isCountry = (cc: string) =>
    store?.countryId === cc ||
    (language?.includes && language.includes("_" + cc));

  return !isCountry("DE");
}

async function fetchStoreContacts(storeId: string) {
  const storeContacts = await getStoreContacts(storeId);
  return storeContacts;
}

export function useStoreContacts() {
  const storeId = useStoreId();
  const result = useQuery({
    queryKey: ["storeContacts", storeId],
    queryFn: async () => await fetchStoreContacts(storeId),
    staleTime: 2 * INTERVAL.MINUTE,
    refetchOnWindowFocus: false,
  });
  return result?.data ?? [];
}

export function useAsMap(list: { id: string }[]) {
  return React.useMemo(
    () =>
      list.reduce((map: any, item: any) => {
        map[item.id] = item;
        return map;
      }, {}),
    [list]
  );
}
